import moment from "moment";

const isMomentLike = (v: any) => moment.isMoment(v);
const isFileLike = (v: any) => v instanceof File || v instanceof Blob;

function appendFormData(form: FormData, value: any, key?: string): void {
  if (value === null || value === undefined || key === undefined) return;

  if (isMomentLike(value)) {
    form.append(key, (value as moment.Moment).toISOString());
    return;
  }

  if (isFileLike(value)) {
    form.append(key, value as Blob);
    return;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return;
    }

    value.forEach((item, idx) => {
      if (isFileLike(item)) {
        form.append(key, item as Blob);
      } else {
        appendFormData(form, item, `${key}[${idx}]`);
      }
    });

    return;
  }

  if (typeof value === "object") {
    Object.entries(value).forEach(([k, v]) => {
      appendFormData(form, v, `${key}.${k}`);
    });
    return;
  }

  form.append(key, String(value));
}

export function toFormData(payload: Record<string, any>): FormData {
  const form = new FormData();

  Object.entries(payload).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    appendFormData(form, v, k);
  });

  return form;
}